// extracted by mini-css-extract-plugin
export default {"bidsList":"BidsList_bidsList__kdVQN","bidsList__switcher":"BidsList_bidsList__switcher__mf2nL"};